export default __webpack_public_path__ + "media/images/messagecards/pink-08850af2f5fb92392c66374182ccc904.jpg";